<template>
  <div>
    <v-card class="mt-4 pt-2 pb-2" flat>
      <v-card-actions>
          <v-row>
              <v-col cols="12" md="4" sm="12">
                  <v-select
          v-model="SelStatus"
          :items="StatusName"
          item-text="event_name"
          item-value="event_id"
          label="Select Event"
          dense
          :rules="[(v) => !!v || 'Event is required']"
          required
        
          @change="getcompanyType"
          hide-details
          full-width
        ></v-select>
              </v-col>
                <!-- @change="getjobType" -->
              <v-col cols="12" md="4" sm="12">
                  <v-select
          v-model="SelCompanyType"
          :items="arrCompanyType"
          item-text="jobtype_name"
          item-value="jobtype_id"
          label="Select Category"
          dense
          :rules="[(v) => !!v || 'Category is required']"
          required
        
        
          hide-details
          full-width
        >
    
      <!-- @change="clearData" -->
    </v-select>
              </v-col>
              <!-- <v-col cols="12" md="3" sm="12">
                  <v-select
          v-model="SelJobType"
          :items="arrJobType"
          item-text="role_name"
          item-value="role_id"
          label="Select Role"
          dense
          :rules="[(v) => !!v || 'Role is required']"
          required
          
        
          hide-details
          full-width
        ></v-select>
              </v-col> -->
              <v-col cols="12" md="3" sm="12">
                   <v-btn color="primary"  raised dark large @click="load" >
          RELOAD

            </v-btn>
              <v-btn
          color="success"
          raised
          dark
          large
          @click="savechanges"
          class="ml-2"
        >
          SAVE CHANGES
        </v-btn>
              </v-col>
            
          </v-row>
        

        
       
      
      </v-card-actions>
    </v-card>
    <v-row>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Choose Roles(s)</v-card-text>

          <v-data-table
            v-model="selected"
            :headers="hdrreason"
            :items="arrreason"
            item-key="role_id"
            dense
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Search"
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>

              <template v-slot:item="{ item }">
              <tr>

<td> <v-btn
                 
              fab
              small
              dark
              color="green"
             outlined
              class="ma-1"
              @click="editItem_BY(item)"
            >
              <v-icon center>mdi-plus</v-icon>
              
            </v-btn></td>

                <td>{{ item.role_id }}</td>
                <td>{{ item.role_name }}</td>
                
                 



              </tr>
            </template>



            

            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Selected Stand(s)</v-card-text>
          <v-data-table
            :headers="hdr1reason"
            :items="arr1reason"
            item-key="msc_name"
            dense
            :loading="loading"
            :search="search1"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search1"
                label="Search"
                single-line
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>
           

            <template v-slot:item="{ item }">
              <tr>

                <td> <v-btn
              
               fab
              small
              dark
             
             outlined
              color="red"
              
              class="ma-1"
              @click="editItem_TO(item)"
            >
              <v-icon center>mdi-delete</v-icon>
              
            </v-btn></td>
                <td>{{ item.role_id }}</td>
                <td>{{ item.role_name }}</td>
 


              </tr>
            </template>



 

            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    successstatus:"primary",
    i:0,
    i_flag:"NEW",
    index:0,
    snackbar: false,
    snackbartext: "",
    snackbarcolor: "primary",
    loading: false,
    checkbox: "",
    chkselected: "",
    selected: [],
    StatusName: [],
    SelStatus: "",
    search: "",
    search1: "",
    btrue: true,
    SelCompanyType:"",
    arrCompanyType:[],
     SelJobType:"",
    arrJobType:[],
    inputclass: {
    //   eid: 0,
    //   cid: 0,
      jobtype_id:0,
      role_id:[],
    },

    arrreason: [],
    hdrreason: [
       { text: "SELECT" },
       { text: "IDS", value: "role_id" },
      { text: "NAME", value: "role_name" },
     
    ],

    arr1reason: [],
    hdr1reason: [
      { text: "SELECT" },
      { text: "ID", value: "role_id" },
      { text: "SELECTED ROLE", value: "role_name" },
    ],

    editedItem: {
      role_id: "",
      role_name: "",
      card_capacity:"0",
      event_id:"",
      mapping_status:"",
    },
  }),
  mounted() {
      this.$store.commit("setPageTitle","Media Job + Role Merge");
     // this.$store.commit("setPageTitle", "Stand Master");
    this.bindEvent();
    // this.Gridbindjobtype();
    // this.Gridbindjobtype(4);
  },
  watch: {
    selected: function () {
    },
    bindEvent: function(){
      
    }

  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },

    addvalue: function (id, name, cid, status) {
      //alert(id + " " + name + " " + cid + " " + status);
      
      console.log(status);
      this.editedItem.reason_id = id;
      this.editedItem.reason_name = name;
      this.editedItem.status_id = cid;
      this.editedItem.mapping_status = "true";
      this.editedItem.card_capacity="0",
      this.arr1reason.push(this.editedItem);
      //  this.arr1jobtype.splice()
    },
    clearData: function () {
      this.arrreason = [];
      this.arr1reason=[];
      this.selected = [];
      
    },

    getcompanyType:function(){
this.bindCompanyType(this.SelStatus);
//this.bindMediaRole(this.SelStatus);
    },

      getjobType:function(){
         this.arrJobType=[];
         this.SelJobType="";
this.bindJobType(this.SelCompanyType);
    },



    editItem_BY: function (item) {
     //  this.inputclass.cid = [];
    // this.arr1reason=[];
    this.successstatus="success";
    this.i_flag="";
    this.i_flag="NEW";
    this.editedItem=[];
       this.editedItem.role_id = item.role_id;
      this.editedItem.role_name = item.role_name;
      this.editedItem.card_capacity ="0";
      if(this.arr1reason.length==0)
      {
this.arr1reason.push(this.editedItem);
this.arrreason.splice(this.arrreason.indexOf(item),1);



      }
      else{

for(this.i=0;this.i<=this.arr1reason.length-1;this.i++)
{
 // alert(this.arr1reason[this.i]["card_id"] + "/" + item.card_id);
  if(this.arr1reason[this.i]["role_name"]== item.role_name)
  {
    
    this.i_flag="EXIST";
    return;
  }
}

//alert(this.i_flag);
if(this.i_flag=="NEW"){
  
this.arr1reason.push(this.editedItem);
this.arrreason.splice(this.arrreason.indexOf(item),1);

}

      }
  //this.selected = this.arrreason.filter(
          //   (task) => task.card_id == this.inputclass.cid
         // );

    },

    editItem_TO: function (item) {
 this.editedItem=[];
 this.editedItem.role_id=item.role_id;
 this.editedItem.role_name=item.role_name;

      this.arr1reason.splice(this.arr1reason.indexOf(item),1);
     this.arrreason.push(this.editedItem);
//  this.selected = this.arrreason.filter(
//             (task) => task.card_id == this.inputclass.cid
//           );

    },

    
    load: function () {
      //alert(SelStatus.)
    //  alert(this.SelStatus.event_name);
      this.selected = [];
      this.loading = true;
      this.Gridbindjobtype(this.SelStatus,this.SelCompanyType);
    },
    savechanges: function () {
      //this.SelStatus,this.SelCompanyType,this.SelJobType
      if(this.arr1reason.length<=0)
      {
        this.showSnackbar("error", "Select Stand before save !");
      return;
      }
      this.inputclass.role_id=[];
     // this.inputclass.eid = this.SelStatus;
    //  this.inputclass.cid = this.SelCompanyType;
      this.inputclass.jobtype_id = this.SelCompanyType;
      this.arr1reason.forEach((el) => {
        this.inputclass.role_id.push(el.role_id);
      });
      
console.log(this.inputclass);
      axios
        .post(this.$apiPath + "Media/MediaJobtypeRoleMapping" , this.inputclass, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          if (res.data.status == "Success") {
            this.showSnackbar("Success", "Role and job mapped successfully !");
             this.Gridbindjobtype(this.SelStatus,this.SelCompanyType);
          }
        })
        .catch()
        .finally();
    },

    handleClick(value) {
      alert(value);
    },
    bindEvent: async function () {
      await axios
        .get(this.$apiPath + "Event", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.StatusName = res.data.result;
        })
        .catch()
        .finally();
    },



 bindCompanyType: async function (eid) {
      await axios
        .get(this.$apiPath + "Media/mediaJobtype/" + eid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.arrCompanyType = res.data.result;
        })
        .catch()
        .finally();
    },



     bindMediaRole: async function (eid) {
      await axios
        .get(this.$apiPath + "Media/mediaRole/" + eid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.arrJobType = res.data.result;
        })
        .catch()
        .finally();
    },

    
 bindJobType: async function (ctid) {
      await axios
        .get(this.$apiPath + "VendorApp/getJobtype/" + ctid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.arrJobType = res.data.result;
        })
        .catch()
        .finally();
    },



    Gridbindjobtype: async function (eid,cid) {
    //  alert(eid + "/"  + cid + "/" + jid);
      await axios
        .get(this.$apiPath + "Media/mediaJobtypeRoleMappingList/" + eid + "/" + cid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          console.log("res",res.data.result);
          this.arrreason = res.data.result;
        //  this.arr1reason = res.data.result;
          this.arr1reason = this.arrreason.filter(
            (task) => task.jobtype_id == this.SelCompanyType
          );
//
          this.arrreason= this.arrreason.filter(n => !this.arr1reason.includes(n));

        })
        .catch()
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>